/* Kategorietabellen für schmale Geräte vorbereiten.
   Gehört nach assets/ps-tabellen.js, geladen in layout/theme.liquid.

   Zwei Aufgaben:
   1. Spaltenüberschrift als data-label an jede Zelle, damit die gestapelte
      Darstellung lesbar bleibt. Das ist reine Optik, für Maschinen wertlos.
   2. ARIA-Rollen und scope setzen. Das ist der wichtige Teil: display:block
      auf tr und td zerstört die Tabellensemantik, ohne die Rollen wäre es
      für Screenreader und Crawler nur noch eine Liste von Blöcken.
      Nebenbei erfüllt es die Baukasten-Regel "immer th scope", die live
      auf keiner Seite eingehalten wird.

   Der Zugriff läuft über [class*="ps-"] und nicht über einzelne Klassen.
   Geprüft am 27.08.2026 auf sieben Kollektionsseiten: alle Tabellen
   gefunden, keine fremde. */

(function () {
  'use strict';

  function aufbereiten(tab) {
    if (tab.dataset.psMobil) return;

    var kopf = tab.querySelectorAll('thead th');
    if (kopf.length < 2) return;

    var namen = Array.prototype.map.call(kopf, function (th) {
      /* Spaltenkoepfe enthalten teils ein Zusatz-Etikett direkt hinter dem
         Namen, ohne Leerzeichen: <th>SUFFOLK<span>hochkant</span></th>.
         textContent klebt beides zusammen. Deshalb ueber die Kindknoten. */
      return Array.prototype.map.call(th.childNodes, function (k) {
        return k.textContent;
      }).join(' ').replace(/\s+/g, ' ').trim();
    });

    tab.setAttribute('role', 'table');

    Array.prototype.forEach.call(tab.querySelectorAll('thead,tbody'), function (g) {
      g.setAttribute('role', 'rowgroup');
    });

    Array.prototype.forEach.call(tab.querySelectorAll('tr'), function (tr) {
      tr.setAttribute('role', 'row');
      var imKopf = tr.closest('thead') !== null;

      Array.prototype.forEach.call(tr.children, function (zelle, i) {
        if (zelle.tagName === 'TH') {
          /* Nicht auf scope verlassen, die Live-Tabellen haben keins.
             Über die Position entscheiden und scope gleich nachtragen. */
          zelle.setAttribute('role', imKopf ? 'columnheader' : 'rowheader');
          if (!zelle.hasAttribute('scope')) {
            zelle.setAttribute('scope', imKopf ? 'col' : 'row');
          }
        } else {
          zelle.setAttribute('role', 'cell');
          if (!zelle.hasAttribute('data-label') && namen[i]) {
            zelle.setAttribute('data-label', namen[i]);
          }
        }
      });
    });

    tab.dataset.psMobil = kopf.length > 2 ? 'stapeln' : 'schmal';

    var rahmen = tab.parentElement;
    if (rahmen && rahmen.tagName === 'DIV') {
      rahmen.classList.add('ps-mobil');
    }
  }

  function los() {
    Array.prototype.forEach.call(
      document.querySelectorAll('[class*="ps-"] table'), aufbereiten);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', los);
  } else {
    los();
  }

  /* Beyond lädt Abschnitte im Theme-Editor nach. */
  document.addEventListener('shopify:section:load', los);
})();
